import { Box, Modal } from '@mui/material'
import React from 'react'

export default function ImageViewerModal({ open, onClose, src }) {
	return (
		<Modal open={open} onClose={onClose} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
			<Box sx={{ bgcolor: 'background.paper', borderRadius: 2, p: 2 }}>
				<img src={src} alt='Full view' style={{ maxWidth: '100%', maxHeight: '80vh', objectFit: 'contain' }} />
			</Box>
		</Modal>
	)
}

